module.exports = __webpack_public_path__ + "static/media/pin.1d6b8d03.png";